import React, { useRef } from "react";
import {
    Card,
    Typography,
    CardContent,
    Grid,
    Tooltip,
} from "@material-ui/core";
import { CardHeader } from "reactstrap";
import moment from "moment";
import ReactToPrint from "react-to-print";
import PrintIcon from "@material-ui/icons/Print";
function PageTemplate({
    label = "Page Title",
    PageActions = false,
    children,
    printLabel = false,
}) {
    const componentRef = useRef();
    let title = document.title;
    return (
        <Card>
            <CardHeader style={{ background: "#0188cc" }}>
                <Grid container spacing={0}>
                    <Grid item xs={6}>
                        <Typography variant="h5" style={{ color: "white" }}>
                            {label}
                        </Typography>
                    </Grid>
                    <Grid item xs={6}>
                        {PageActions ? PageActions : ""}
                        <ReactToPrint
                            onBeforePrint={() => {
                                setTimeout(undefined, 2000);
                                document.title = printLabel
                                    ? printLabel
                                    : label +
                                      " - " +
                                      moment().format("DD-MM-YYYY HH:mm:ss");
                            }}
                            onAfterPrint={() => {
                                document.title = title;
                            }}
                            trigger={() => (
                                <Tooltip title="Print Page">
                                    <PrintIcon
                                        style={{
                                            margin: 4,
                                            color: "white",
                                            float: "right",
                                            cursor: "pointer",
                                        }}
                                    />
                                </Tooltip>
                            )}
                            content={() => componentRef.current}
                        />
                    </Grid>
                </Grid>
            </CardHeader>
            <CardContent ref={componentRef}>{children}</CardContent>
        </Card>
    );
}
export default PageTemplate;
